import type { Except, Merge } from 'type-fest';
import { useField } from '../../../hooks/useField';
import {
    Controlled_StringInput,
    type Controlled_StringInputProps,
} from '../../inputs/controlled/Controlled_StringInput';
import type { StringOrNullableString } from '../../inputs/controlled/types';

export type Form_StringInputProps<T extends object, N extends boolean> = Merge<
    Except<
        Controlled_StringInputProps<N>,
        keyof useField.Result<StringOrNullableString<N>>
    >,
    useField.Props<StringOrNullableString<N>, T>
>;

export const Form_StringInput = <T extends object, N extends boolean>({
    name,
    control,
    onChange,
    ...props
}: Form_StringInputProps<T, N>) => {
    const fieldProps = useField({
        name,
        control,
        onChange,
    });

    return (
        <Controlled_StringInput
            {...props}
            {...fieldProps}
        />
    );
};
